import { render } from "./DistributorInvoices.vue?vue&type=template&id=4633ff8c&scoped=true"
import script from "./DistributorInvoices.vue?vue&type=script&lang=js"
export * from "./DistributorInvoices.vue?vue&type=script&lang=js"

import "./DistributorInvoices.vue?vue&type=style&index=0&id=4633ff8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4633ff8c"]])

export default __exports__